<template>
  <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
    <template slot="topNoSelectMenus" slot-scope="props">
      <grid-top-menu v-if="props.magicalMenuCodes.includes('menu-a')">菜单B</grid-top-menu>
    </template>
    <template slot="headerColumns" slot-scope="props">
      <grid-table-th
        v-if="props.magicalMenuCodes.includes('menu-a')"
        width="60px"
      >操作</grid-table-th>
    </template>
    <template slot="bodyColumns" slot-scope="props">
      <grid-table-td
        v-if="props.magicalMenuCodes.includes('menu-a')"
        width="60px"
      >菜单A</grid-table-td>
    </template>
  </grid>
</template>
<script>
  import Grid from '../../../components/grid/grid.vue'
  import GridTableTh from '../../../components/grid-menu/grid-table-th'
  import GridTableTd from '../../../components/grid-menu/grid-table-td'
  import GridTopMenu from '../../../components/grid-menu/grid-top-menu'
  export default {
    components: {
      GridTopMenu,
      GridTableTd,
      GridTableTh,
      Grid
    },
    name: 'demo-student-manage-dc',
    data() {
      return {
        gridConfigUrl: ''
      }
    },
    created() {
      this.gridConfigUrl = this.$route.meta.url
    }
  }
</script>



// WEBPACK FOOTER //
// src/custom/components/grid/demo-student-manage-dc.vue